import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker } from "@fortawesome/pro-light-svg-icons";

import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

import { getEnvVariable, REACT_APP_COCKPIT_URL } from "utils/environment";
import { Page, StateRedux } from "types/generic";
import MainLayoutSidenavButton from "./mainlayoutsidenavbutton";

type MainLayoutSidenavProps = {
  pages: Page[];
  showHierarchy: boolean;
  currentSelectedPage: string;
  setCurrentSelectedPage: (id: string) => void;
  isExpanded: boolean;
};

const MainLayoutSidenav = ({
  pages,
  currentSelectedPage,
  setCurrentSelectedPage,
  showHierarchy,
  isExpanded,
}: MainLayoutSidenavProps) => {
  const history = useHistory();
  const intl = useIntl();

  const useRedux = useSelector((state: StateRedux) => state);
  const userRoles = useRedux.keycloak.userRoles;

  const getSelectedPageId = () => {
    let currentPath: string[] = history.location.pathname.split("/").splice(1);

    if (currentPath.length >= 2 && pages.length > 0) {
      return currentPath[1];
    }
  };

  const generateHierarchyButton = () => {
    if (showHierarchy) {
      return (
        <div className="l-main-layout-sidenav__hierarchy sidenav-button-container">
          <MainLayoutSidenavButton
            isActive={false}
            isExpanded={isExpanded}
            icon={() => <FontAwesomeIcon icon={faMapMarker} />}
            title={"Hierarchy"}
            onClick={() => {}}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const generateButtons = () => {
    const buttons: JSX.Element[] = [];

    for (let index = 0; index < pages.length; index++) {
      let currentPage = pages[index];
      // Remove the first entry, since it will be always empty due to the split
      let currentPath: string[] = history.location.pathname
        .split("/")
        .splice(1);
      let layoutRoute: string = currentPath[0];

      if (currentPath.length < 1 && pages && pages.length > 0) {
        history.replace(`/${layoutRoute}/${pages[0].id}/`);
      }

      buttons.push(
        <MainLayoutSidenavButton
          isActive={getSelectedPageId() === currentPage.id}
          isExpanded={isExpanded}
          icon={() => currentPage.icon()}
          title={intl.formatMessage({ id: `app.menu.${currentPage.id}` })}
          onClick={() => {
            if (currentPage.id === "cockpit") {
              window.open(getEnvVariable(REACT_APP_COCKPIT_URL), "_blank");
            } else {
              history.push(`/${layoutRoute}/${currentPage.id}`)
            }
          }}
          key={"id_" + currentPage.id}
        />
      );
    }

    return buttons;
  };

  return (
    <div className="l-main-layout-sidenav">
      {generateHierarchyButton()}
      <div className="l-main-layout-sidenav__middle sidenav-button-container">
        {generateButtons()}
      </div>
      <div className="l-main-layout-sidenav__bottom sidenav-button-container"></div>
    </div>
  );
};

export default MainLayoutSidenav;
